export const currencyFormat = {
  methods: {
    currencyFormat(value) {
      return parseFloat(value.toString()).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    }
  }
};